<template>
    <div
        v-if="advertiserId"
        class="af-apply-with-option af-apply-with-seek"
    >
        <div
            class="af-apply-with-item afu-p-5 afu-flex afu-items-center afu-justify-center afu-shadow-lg afu-rounded-btn afu-bg-white afu-cursor-pointer afu-border afu-border-solid afu-border-transparent hover:afu-border-solid hover:afu-border hover:afu-border-secondary-light"
            @click="handleApplyWith()"
        >
            <img
                :src="getLogo"
                alt="Apply with seek"
            >
            <span
                v-if="$mq !== 'sm'"
                class="afu-text-secondary afu-text-base afu-font-semibold afu-ml-2"
            >
                SEEK
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Seek',

        data() {
            return {
                jobUuid: '',
                advertiserId: window?.afConfig?.seek_advertiser_id,
            };
        },

        async created() {
            this.jobUuid = this.$route.params.uuid;
        },

        computed: {
            getLogo() {
                return `${process.env.VUE_APP_URL}${require('@/assets/img/seek.svg')}`;
            },
        },

        methods: {
            handleApplyWith() {
                const redirectUrl = `${process.env.VUE_APP_OAUTH_CALLBACK_URL}?cbtype=seek&cbaction=apply`;
                let returnUrl = process.env.VUE_APP_SEEK_OAUTH_URL;
                returnUrl = `${returnUrl}?client_id=${process.env.VUE_APP_SEEK_CLIENT_ID}`;
                returnUrl = `${returnUrl}&redirect_uri=${encodeURIComponent(redirectUrl)}`;
                returnUrl = `${returnUrl}&scope=r_profile_apply`;
                returnUrl = `${returnUrl}&response_type=code`;
                returnUrl = `${returnUrl}&state=${this.jobUuid}|${encodeURIComponent(window.location.href.split('?')[0])}|${this.advertiserId}`;
                returnUrl = `${returnUrl}&advertiser_id=${this.advertiserId}`;
                window.location.href = returnUrl;
            },
        },
    };
</script>
